/*
 * Copyright (c) 2022. American Express Company
 */

import React from 'react';
import { IconWarning } from '@americanexpress/dls-react';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import Typography from 'src/components/typography/Typography';
import Card from 'src/components/atomic/atoms/card/Card';
import ProgressBar from 'src/components/atomic/atoms/progressBar/ProgressBar';
import vars from 'src/styles/variables.module.scss';

import { props } from 'src/types/view-models/savingsRecap.view.model';

import styles from './savingsRecap.module.scss';
import { CardVariant } from 'src/types/card-variant.enum';

export default function SavingsRecap({ currentPercent, percentDifference, goTo, showWarning }: props): JSX.Element {
    return (
        <Card variant={CardVariant.SECONDARY} className={styles.savingsRecap}>
            <div>
                <Typography variant={TypographyVariants.BODY}>
                    {LiteralsService.getLiteral('Insights.savingsRecap.pctCloser', [percentDifference])}
                </Typography>
                <Typography variant={TypographyVariants.CAPTION}>
                    {currentPercent}
                    {LiteralsService.getLiteral('Insights.savingsRecap.pctComplete')}
                </Typography>
            </div>
            <ProgressBar percentage={currentPercent} compact />
            {showWarning && (
                <Card variant={CardVariant.TERTIARY} row>
                    <IconWarning style={{ fill: vars.warning }} />
                    <Typography variant={TypographyVariants.SUBTEXT}>
                        {LiteralsService.getLiteral('Insights.savingsRecap.warning[0]')}
                        <Anchor onClick={() => goTo('/goals')}>
                            {LiteralsService.getLiteral('Insights.savingsRecap.warning[1]')}
                        </Anchor>
                        {LiteralsService.getLiteral('Insights.savingsRecap.warning[2]')}
                        <Anchor onClick={() => goTo('/goals')}>
                            {LiteralsService.getLiteral('Insights.savingsRecap.warning[3]')}
                        </Anchor>
                        {LiteralsService.getLiteral('Insights.savingsRecap.warning[4]')}
                        <Anchor onClick={() => goTo('/goals')}>
                            {LiteralsService.getLiteral('Insights.savingsRecap.warning[5]')}
                        </Anchor>
                        {LiteralsService.getLiteral('Insights.savingsRecap.warning[6]')}
                    </Typography>
                </Card>
            )}
        </Card>
    );
}
